<template>
  <div class="fulfillment-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "fulfillmentBase",
};
</script>
